import DOMPurify from 'dompurify';

import type { SanitizerContext } from 'handsontable';

/**
 * Sanitizes HTML before Handsontable writes it to the DOM (column headers, context menus, select
 * options and pasted clipboard HTML). Handsontable 18 dropped its bundled DOMPurify, so without
 * this option HTML built from user-provided values (e.g. metadata titles in headers) is written raw.
 * Pasted HTML keeps the `<meta>` tags spreadsheet apps add, which Handsontable reads during parsing.
 */
export const hotSanitizer = (content: string, source?: SanitizerContext): string => {
  if (typeof source === 'string' && source.startsWith('CopyPaste.paste')) {
    return DOMPurify.sanitize(content, { ADD_TAGS: ['meta'], ADD_ATTR: ['content'], FORCE_BODY: true });
  }
  return DOMPurify.sanitize(content);
};
